import {
	NgModule
} from '@angular/core';

import {
	CommonModule
} from '@angular/common';

import {
	RouterModule
} from '@angular/router';

import {
	ReactiveFormsModule
} from '@angular/forms';

import {
	Dd1pndsNgBannerModule,
	Dd1pndsNgButtonComponent,
	Dd1pndsNgButtonModule,
	Dd1pndsNgCardModule,
	Dd1pndsNgErrorComponent,
	Dd1pndsNgErrorModule,
	Dd1pndsNgFooterModule,
	Dd1pndsNgHeaderModule,
	Dd1pndsNgLinkComponent,
	Dd1pndsNgLinkModule,
	Dd1pndsNgLinkV2Component,
	Dd1pndsNgLinkV2Module,
	Dd1pndsNgLoginHistoryModalComponent,
	Dd1pndsNgLoginHistoryModalModule,
	// Page maintenance
	Dd1pndsNgMaintenanceModule,
	Dd1pndsNgPageHeaderComponent,
	Dd1pndsNgPageHeaderModule,
	Dd1pndsNgPopinsModule,
	MaterialModule
} from 'dd1pnds-ngx-libs';

import {
	Dd1pndsNgFaqContentComponent
} from './components/dd1pnds-ng-faq-content/dd1pnds-ng-faq-content.component';

const importModules = [
	CommonModule,
	MaterialModule,
	RouterModule,
	ReactiveFormsModule,
	Dd1pndsNgHeaderModule,
	Dd1pndsNgBannerModule,
	Dd1pndsNgButtonModule,
	Dd1pndsNgCardModule,
	Dd1pndsNgLinkModule,
	Dd1pndsNgLinkV2Module,
	Dd1pndsNgPageHeaderModule,
	Dd1pndsNgErrorModule,
	Dd1pndsNgLoginHistoryModalModule,
	// Page maintenance
	Dd1pndsNgMaintenanceModule,
	Dd1pndsNgFooterModule,
	Dd1pndsNgPopinsModule
];

const modulesDeclarations = [
	Dd1pndsNgFaqContentComponent
];

const exportModules = [
	CommonModule,
	MaterialModule,
	Dd1pndsNgErrorComponent,
	Dd1pndsNgHeaderModule,
	Dd1pndsNgLinkComponent,
	Dd1pndsNgLinkV2Component,
	Dd1pndsNgBannerModule,
	Dd1pndsNgButtonComponent,
	Dd1pndsNgCardModule,
	Dd1pndsNgFaqContentComponent,
	Dd1pndsNgPageHeaderComponent,
	Dd1pndsNgLoginHistoryModalComponent,
	// Page maintenance
	Dd1pndsNgMaintenanceModule,
	Dd1pndsNgFooterModule,
	Dd1pndsNgPopinsModule
];

@NgModule({
	declarations: [...modulesDeclarations],
	imports: [...importModules],
	exports: [...exportModules]
})

export class SharedModule { }
